import { render, staticRenderFns } from "./EstadoProcesoDetail.vue?vue&type=template&id=d8d0948e&scoped=true"
import script from "./EstadoProcesoDetail.vue?vue&type=script&lang=js"
export * from "./EstadoProcesoDetail.vue?vue&type=script&lang=js"
import style0 from "./EstadoProcesoDetail.vue?vue&type=style&index=0&id=d8d0948e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d0948e",
  null
  
)

export default component.exports